<template lang='pug'>
section
  s-page-title(:title='title' :previous='true')
  v-expansion-panel(v-if='details && details.steps' v-model='opened')
    v-expansion-panel-content(
      v-for='(step, index) in details.steps'
      v-if='step'
      :key='index'
    )
      div(slot='header')
        span(class='step-title') {{ step.name }}
      v-card
        v-card-text(class='px-4')
          step-desc(:text='step.text' :client='client' class='mb-4')
          deal(
            v-if='steps.deal == step.alias'
            :step='step'
            :client='client'
            :details='details'
          )
          constructing(v-else-if='steps.constructing == step.alias' :step='step')
          exploitation(v-else-if='steps.exploitation == step.alias' :step='step')
          ownership(v-else-if='steps.ownership == step.alias' :step='step')
          man-company(
            v-else-if='steps.mancompany == step.alias'
            :step='step'
            class='mt-5'
          )
  s-no-data(v-else-if='!isLoading')
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Deal from './steps/Deal'
import StepDesc from './steps/StepDesc'
import Ownership from './steps/Ownership'
import ManCompany from './steps/ManCompany'
import Constructing from './steps/Constructing'
import Exploitation from './steps/Exploitation'

import { get } from 'lodash'

export default {
  props: ['id'],

  data: () => ({
    opened: null,
    steps: {
      deal: 'step1',
      constructing: 'step2',
      exploitation: 'step3',
      ownership: 'step4',
      mancompany: 'step5'
    }
  }),

  components: {
    StepDesc,
    Deal,
    Constructing,
    Exploitation,
    Ownership,
    ManCompany
  },

  created() {
    this.fetchDealDetails({
      id: this.id,
      is_share: this.$route.query.is_share
    })
  },

  methods: mapActions('client/deals', ['fetchDealDetails']),

  computed: {
    title() {
      return get(this.details, 'info_deal.object_name', null)
    },

    details() {
      return this.dealById(this.id)
    },

    ...mapGetters('auth', ['client']),
    ...mapGetters('client/deals', ['dealById', 'isLoading'])
  },

  watch: {
    details(deal) {
      this.$nextTick(() => {
        if (deal && deal.steps) {
          Object.keys(deal.steps).forEach((k, i) => {
            if (deal.steps[k] && deal.steps[k].current) {
              this.opened = i
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.step-title {
  font-size: 18px;
  font-weight: 500;
}
</style>
